import Layout from './components/Layout';

// public
import Intro from './components/Intro';
import Main from './components/Main';
import SuccessStory from './components/SuccessStory';
import News from './components/News';
import NewsPost from './components/NewsPost';
import Partners from './components/Partners';
import About from './components/About';
import Programs from './components/Programs';
import Manage from './components/Manage';
import Promotion from './components/Promotion';
import AnalyticalCoverage from './components/AnalyticalCoverage';
import Contacts from './components/Contacts';
import Career from './components/Career';
import Support from './components/Support';
import Examples from './components/Examples';
import Subnavigation from './components/Subnavigation';
import Chart from './components/Chart';
import Investors from './components/Investors';
import NotFound from './components/NotFound';

function forceTrailingSlash(nextState, replace) {
  const path = nextState.location.pathname;
  if (path.slice(-1) !== '/') {
    replace({
      ...nextState.location,
      pathname: path + '/'
    });
  }
}

function onRouteChange(prevState, nextState, replace) {
  forceTrailingSlash(nextState, replace);
}

export default (store) => ({
  onEnter: forceTrailingSlash,
  onChange: onRouteChange,
  childRoutes: [
    {
      component: Layout,
      path: '/',
      indexRoute: {
        component: Investors(store).component,
        onEnter: Investors(store).onEnter
      },
      childRoutes: [
        // ...Investors(store),
        // ...News(store), //
        // ...NewsPost(store), //
        // Investors(store),
        // Chart(store),
        // About(store),
        // Partners(store),
        // Contacts(store),
        // Career(store),
        // AnalyticalCoverage(store),
        // ...Subnavigation,
        // ...SuccessStory(store), //
        // ...Manage(store), //
        // ...Programs(store), //
        // ...Support(store), //
        // ...Promotion(store),
        // ...Examples(store), //
        NotFound
      ]
    }
  ]
});



// WEBPACK FOOTER //
// ./src/routes.js